import { put } from 'helpers/api';

export const UPDATE_PLUGIN_SET_FILTER = 'update_plugin_filter';
export const UPDATE_PLUGIN_SET_FILTER_ORDER = 'update_plugin_set_filters';
export const UPDATE_PLUGIN_SET = 'update_plugin_set';
export const ADD_PLUGIN_SET_FILTER = 'add_plugin_set_filter';

const transformPluginFilterData = (pluginFilter) => {
  if (pluginFilter.isNew || pluginFilter.isDefault) {
    const { ...filterToSave } = pluginFilter;
    delete filterToSave.isNew;
    delete filterToSave.isDefault;
    delete filterToSave.id;
    return filterToSave;
  }
  return pluginFilter;
};

export function savePluginSetFilters(pluginSetId, pluginFilters, defaultPluginFilters, successCallback, errorCallback) {
  const filters = pluginFilters.map(filter => transformPluginFilterData(filter));
  const params = { pluginsPluginSet: { pluginFiltersAttributes: filters } };

  return (dispatch) => {
    return put(`/plugins/plugin_sets/${pluginSetId}`, params).then(({ pluginSet }) => {
      const hasPersistedPendingDestroys = pluginFilters.some((filter) => {
        return filter._destroy && !filter.isDefault && !filter.isNew;
      });
      const shouldUseDefaults = hasPersistedPendingDestroys &&
        pluginSet.pluginFilters.length === 0 && defaultPluginFilters;

      dispatch({
        type: UPDATE_PLUGIN_SET,
        payload: shouldUseDefaults ? { ...pluginSet, pluginFilters: defaultPluginFilters } : pluginSet
      });
      if (successCallback) successCallback();
    }).catch((errors) => {
      if (errorCallback) errorCallback(errors);
    });
  };
}

export function updateFilterOrder(index1, index2) {
  return {
    type: UPDATE_PLUGIN_SET_FILTER_ORDER,
    payload: [index1, index2]
  };
}

export function updateFilter(id, key, value) {
  return {
    type: UPDATE_PLUGIN_SET_FILTER,
    payload: { id, key, value }
  };
}

export function addFilter() {
  return {
    type: ADD_PLUGIN_SET_FILTER,
    payload: {
      id: Math.floor(Math.random() * 10000),
      filterField: '',
      isNew: true,
      metric: false,
      defaultValue: '',
      propertyTypes: []
    }
  };
}
